import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  CASH_TRANSACTION_CODE,
  PAYMENT_BODY_PARAMS_RESULT,
  PAYMENT_BODY_RESULT,
  PAYMENT_DETAIL_TYPE,
  TXN_PAYOUT_BODY_RESULT,
} from 'models';

export interface searchFeeType {
  searchFee: {
    searchFee_list: PAYMENT_BODY_PARAMS_RESULT;
    searchFee_detail: any | null;
    payouts: PAYMENT_BODY_PARAMS_RESULT;
    payouts_detail: PAYMENT_DETAIL_TYPE | null;
    txn_payout_list: TXN_PAYOUT_BODY_RESULT;
  };
}

export const initialSearchFeeState: searchFeeType = {
  searchFee: {
    payouts: {
      params: {
        page: 1,
        limit: 50,
        code: CASH_TRANSACTION_CODE.SEARCH_FEE,
      },
      records: [],
      metadata: {
        page: 1,
        limit: 50,
        page_count: 1,
        total_pages: 1,
        total_count: 1,
      },
    },
    searchFee_list: {
      records: [],
      metadata: {
        page: 1,
        limit: 50,
        page_count: 1,
        total_pages: 1,
        total_count: 1,
      },
      params: {
        page: 1,
        limit: 50,
        code: CASH_TRANSACTION_CODE.SEARCH_FEE,
      },
    },
    searchFee_detail: null,
    payouts_detail: null,
    txn_payout_list: {
      params: {
        page: 1,
        limit: 10,
      },
      records: [],
      metadata: {
        page: 1,
        limit: 10,
        page_count: 1,
        total_pages: 1,
        total_count: 1,
      },
    },
  },
};

const searchFeeSlice = createSlice({
  name: 'searchFee',
  initialState: initialSearchFeeState,
  reducers: {
    setSearchFeeListSuccess(
      state: searchFeeType,
      action: PayloadAction<PAYMENT_BODY_RESULT>
    ) {
      state.searchFee.searchFee_list = {
        ...state.searchFee.searchFee_list,
        ...action.payload,
      };
    },
  },
});

// Actions
export const { setSearchFeeListSuccess } = searchFeeSlice.actions;

export default searchFeeSlice.reducer;
